var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "scout-form",
    { attrs: { label: "除外する会員を指定", "has-child": "" } },
    [
      _c(
        "dummy-scout-form",
        {
          attrs: {
            "is-modified": _vm.isModifiedThisJob,
            label: "この自社求人でスカウトした時期を指定して除外",
            "data-test": "scout-this-job",
          },
        },
        [
          _c("term-select", {
            attrs: {
              "selected-option": _vm.scoutThisJobOption,
              from: _vm.scoutThisJobFrom,
              to: _vm.scoutThisJobTo,
              notice:
                "※現在の掲載期間中にスカウトした会員は、スカウト済み一覧から再送できるため、すでに除外されています。現在の掲載期間よりも前にスカウトしたことがある会員を除外したい場合に、こちらを指定してください。",
              "date-label": "スカウト送信日",
            },
            on: {
              "update:selectedOption": function ($event) {
                _vm.scoutThisJobOption = $event
              },
              "update:selected-option": function ($event) {
                _vm.scoutThisJobOption = $event
              },
              "update:from": function ($event) {
                _vm.scoutThisJobFrom = $event
              },
              "update:to": function ($event) {
                _vm.scoutThisJobTo = $event
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "dummy-scout-form",
        {
          attrs: {
            "is-modified": _vm.isModifiedOtherJob,
            label: "その他の自社求人でスカウトした時期を指定して除外",
            "data-test": "scout-other-job",
          },
        },
        [
          _c("term-select", {
            attrs: {
              "selected-option": _vm.scoutOtherJobOption,
              from: _vm.scoutOtherJobFrom,
              to: _vm.scoutOtherJobTo,
              "date-label": "スカウト送信日",
            },
            on: {
              "update:selectedOption": function ($event) {
                _vm.scoutOtherJobOption = $event
              },
              "update:selected-option": function ($event) {
                _vm.scoutOtherJobOption = $event
              },
              "update:from": function ($event) {
                _vm.scoutOtherJobFrom = $event
              },
              "update:to": function ($event) {
                _vm.scoutOtherJobTo = $event
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "dummy-scout-form",
        {
          attrs: {
            "is-modified": _vm.hasCandidateOtherJob,
            "data-test": "candidate-other-job",
            label: "送信候補",
          },
        },
        [
          _c("label", { staticClass: "boss-checkbox" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.hasCandidateOtherJob,
                  expression: "hasCandidateOtherJob",
                },
              ],
              staticClass: "boss-input-checkbox",
              attrs: { type: "checkbox", "data-test": "applies-other-company" },
              domProps: {
                checked: Array.isArray(_vm.hasCandidateOtherJob)
                  ? _vm._i(_vm.hasCandidateOtherJob, null) > -1
                  : _vm.hasCandidateOtherJob,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.hasCandidateOtherJob,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.hasCandidateOtherJob = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.hasCandidateOtherJob = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.hasCandidateOtherJob = $$c
                  }
                },
              },
            }),
            _vm._v("その他の自社求人で送信候補に入れている会員を除外\n    "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "boss-annotation-text" }, [
            _vm._v(
              "\n      ※この自社求人で送信候補に入れている会員はすでに除外されています。\n    "
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("scout-form-other-excludes", {
        attrs: { "applies-other-company": _vm.appliesOtherCompany },
        on: {
          "update:appliesOtherCompany": function ($event) {
            return _vm.$emit("update:applies-other-company", $event)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }